<template>
  <register-view>
    <form ref="form" @submit.prevent="onSubmit">
      <fields layout="vertical" />
      <button
        :disabled="!model.agree"
        type="submit"
        class="btn bg-teal-400 btn-block"
      >
        {{ strings.auth.sign_in }}
        <i class="icon-circle-right2 ml-2"></i>
      </button>
    </form>
  </register-view>
</template>

<script>
import RegisterForm from 'stylemix-vue-admin/modules/auth/RegisterForm'

export default {
  name: 'RegisterForm',
  extends: RegisterForm,
  methods: {
    loadForm() {
      const self = this
      this.$uiBlocker(
        this.$http.get('auth/register').then(({ data }) => {
          data.fields.push({
            component: 'checkbox-field',
            attribute: 'agree',
            get label() {
              return self.$t('vendor.admin.auth.register_agreement')
            },
          })
          this.setFields(data.fields)
          this.model = data.data
        }),
        this.$refs.form,
      )
    },
  },
}
</script>
